
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage'
import "firebase/storage";



const firebaseConfig = {
    apiKey: "AIzaSyAnvGOApboDJ1Ln65-SqHxq6F-EHI3nOkk",
  authDomain: "vilasclub-resort.firebaseapp.com",
  projectId: "vilasclub-resort",
  storageBucket: "vilasclub-resort.firebasestorage.app",
  messagingSenderId: "636377455659",
  appId: "1:636377455659:web:be51fa5ef368bceca01e6e",
  measurementId: "G-606KMBWJ84"

};
//init firebase app
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const db = getFirestore(app);




export default app;